import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getCountryNameByCountryCode, getOrderTypeText } from '../../../../../utils/utility';

export default function indirectCustomerCTInitialQuotesColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    let prefillingData = {};

    config.data.forEach((quote, index) => {
        let row = [];
        const rowId = quote.quoteId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let linkDestination = null;
            let isDisabled = false;

            if (columnDataType === "link") {
                if (columnId === "quoteId") {
                    columnValue = quote.quoteId || "";
                    linkDestination = '/recycle';
                    prefillingData = { quoteId: quote.quoteId, prefilledCountryCode: quote.countryCode, fromCTQuotes: "/quotes/indirect-customers" };
                }
            }
            else if (columnDataType === "string") {
                if (columnId === "quoteCreationDate") {
                    columnValue = getDateWithSpecificFormat(quote.createdDate);
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(quote.orderType) || "";
                }
                else if (columnId === "company") {
                    columnValue = quote.company || "";
                }
                else if (columnId === "customerEmailAddress") {
                    columnValue = quote.email || "";
                }
                else if (columnId === "country") {
                    columnValue = getCountryNameByCountryCode(quote.countryCode) || "";
                }
                else if (columnId === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.status) || "";
                }
                else if (columnId === "currencyCode") {
                    columnValue = quote.currencyCode || "";
                }
                else if (columnId === "quantityOfAssets") {
                    columnValue = quote.assetQty || "";
                }
                else if (columnId === "quotedNetValue") {
                    columnValue = quote.netValue || "";
                }
                else if (columnId === "quotedHWBuybackValue") {
                    columnValue = quote.chwBuyBackValue || "";
                }
                else if (columnId === "quotedServiceCosts") {
                    columnValue = quote.cserviceCost || "";
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    linkDestination: linkDestination,
                    prefillingData: prefillingData,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
